<template>
  <div class="bash-box price-box">
    <p>{{ indata.FirstTitle }}</p>
    <ul>
      <li>
        <a class="go-next" :href="indata.btnUrl1" target="_blank">免费试用</a>
      </li>
      <li><a :href="indata.btnUrl2" target="_blank">实例演示</a></li>
    </ul>
  </div>
</template>
<style scoped src="../../public/css/drp.css">
</style>
<script>
export default {
  name: "Templates9",
  props: {
    indata: Array,
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>